import React, { FC, useRef, useState } from "react";
import { TextInput } from "react-native";
import { useFormContext } from "react-hook-form";

import { VnTextInput } from "@/components/VnTextInput/VnTextInput.tsx";
import { CoverageCheckFormType } from "@/domain/householdMember";
import { ssnMask } from "@/utils/string";

import { SecureTextEntryToggle } from "./SecureTextEntryToggle";

export const CoverageCheckForm: FC = () => {
  const { control } = useFormContext<CoverageCheckFormType>();
  const [isSsnVisible, setIsSsnVisible] = useState(false);

  const ssnRef = useRef<TextInput>(null);
  const medicaidSubscriberIdRef = useRef<TextInput>(null);

  return (
    <>
      <VnTextInput
        autoFocus
        name="ssn"
        control={control}
        labelI18nKey="native:addHouseholdMemberScreen.coverageCheck.ssn"
        placeholderI18nKey="native:addHouseholdMemberScreen.coverageCheck.ssnPlaceholder"
        mask={{
          maskGenerator: ssnMask,
        }}
        isRequired={false}
        ref={ssnRef}
        returnKeyType="next"
        onSubmitEditing={() => medicaidSubscriberIdRef.current?.focus()}
        secureTextEntry={!isSsnVisible}
        keyboardType="numeric"
        isPasswordField={false}
        rightElement={
          <SecureTextEntryToggle
            isVisible={isSsnVisible}
            onPress={() => setIsSsnVisible(prev => !prev)}
          />
        }
      />
      <VnTextInput
        name="medicaidSubscriberId"
        control={control}
        labelI18nKey="native:profileInformationScreen.medicaidSubscriberId"
        placeholderI18nKey="native:addHouseholdMemberScreen.coverageCheck.medicaidIdPlaceholder"
        isRequired={false}
        ref={medicaidSubscriberIdRef}
        returnKeyType="done"
      />
    </>
  );
};
